import { render, staticRenderFns } from "./OutputItem.vue?vue&type=template&id=3a70083c&"
import script from "./OutputItem.vue?vue&type=script&lang=ts&"
export * from "./OutputItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports